import * as Styled from './Loader.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Button 3-dot loader component.
 *
 * ! Only tested with our Button atoms. May or may not work in other contexts.
 *
 * <div style="display:none;"><!-- don't display in storybook -->
 * LoaderContainer
 *   Buttons use `display: inline-flex` to perfectly center the button's icon and label. This
 *   component ensures the loader is the only flex child so that we don't have to mess with flexbox.
 *
 * DotFlashingLoaderContainer
 *   Absolutely positions the loader over the entire button and centers it.
 *
 * DotFlashingLoader
 *   The 3-dots loader.
 *
 * HideButtonLabel
 *   Wraps the button's original children and sets its opacity to zero to hide it. Using opacity
 *   lets us maintain the button's width and height when swapping in the loader without resorting
 *   to calculating/setting its dimensions at runtime.
 * </div>
 */
export const Loader = ({
  children,
  circleDiameter,
  circleSpacing,
  ...rest
}) => /*#__PURE__*/_jsxs(Styled.LoaderContainer, {
  circleDiameter: circleDiameter,
  circleSpacing: circleSpacing,
  children: [/*#__PURE__*/_jsx(Styled.DotFlashingLoaderContainer, {
    ...rest,
    children: /*#__PURE__*/_jsx(Styled.DotFlashingLoader, {})
  }), /*#__PURE__*/_jsx(Styled.HideButtonLabel, {
    children: children
  })]
});